(() => {
  const mount = root => root.querySelectorAll('[data-lus-gift]').forEach(gift => {
    if (gift.dataset.giftReady) return;
    gift.dataset.giftReady = 'true';
    const input = gift.querySelector('.product-variant-id');
    const price = gift.querySelector('[data-gift-price]');
    gift.addEventListener('click', event => {
      const button = event.target.closest('[data-gift-variant]');
      if (!button || button.disabled) return;
      gift.querySelectorAll('[data-gift-variant]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      if (input) { input.value = button.dataset.giftVariant; input.dispatchEvent(new Event('change', { bubbles: true })); }
      gift.querySelector('recipient-form')?.setAttribute('data-product-variant-id', button.dataset.giftVariant);
      if (price) price.textContent = button.dataset.giftPrice || '';
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document)); else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
